<!--
  cellAth.vue ( 2-1 step, mblElcSgn01 )
  - 휴대폰 인증
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header type="type_form" />
    <!--Container [s]-->
    <div class="container">
      <div class="contents type2">
        <!-- 폼 페이지 컨텐츠 간격 클래스 : type2 -->
        <!--Contents Area [s]-->
        <div class="section">
          <div class="form_wrap">
            <ul>
              <InputArea label="성명" v-model="state.fnm"></InputArea>
              <InputArea
                v-if="!isRpsMbl"
                label="생년월일"
                v-model="state.bdt"
                length="8"
                inputType="tel"
                placeholder="생년월일 입력 예)19000101"
              ></InputArea>
              <li v-if="isRpsMbl">
                <label for="bitrhInput">주민등록번호</label>
                <div class="form_area_multi">
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        type="tel"
                        id="bitrhInput"
                        class="form_input"
                        placeholder="주민등록번호 앞자리"
                        maxlength="6"
                        v-model="state.bdt"
                      />
                    </div>
                    <div class="form_guide">
                      <!-- 에러일 경우 : error 클래스 추가 -->
                      <p class="txt_alert">
                        <span>생년월일을 입력하세요.</span>
                      </p>
                    </div>
                  </div>
                  <div class="hyphen"></div>
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        type="password"
                        id="idfNo"
                        name="idfNo"
                        class="form_input bg_pw"
                        maxLength="7"
                        placeholder="●●●●●●●"
                        ref="idfNoEl"
                        data-tk-kbdType="number"
                        onfocus="mtk.onKeyboard(this);"
                      />
                    </div>
                    <div class="form_guide">
                      <!-- 에러일 경우 : error 클래스 추가 -->
                      <p class="txt_alert">
                        <span>주민등록번호를 입력하세요.</span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <label for="">휴대폰번호</label>
                <div class="form_area_multi">
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        @click="openCcoCdSelectBox()"
                        id="phoneInput"
                        class="form_input type_select"
                        placeholder="통신사"
                        :value="state.ccoCd.name"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="space"></div>
                  <div class="form_box">
                    <div class="form_area">
                      <input
                        type="tel"
                        class="form_input"
                        maxlength="11"
                        placeholder="- 없이 입력"
                        v-model="state.cellNo"
                        @keyup="validateInput"
                        @blur="validateInput"
                        v-numeric-only
                      />
                    </div>
                    <div class="form_guide" :class="errors[id] ? 'error' : ''">
                      <!-- 에러일 경우 : error 클래스 추가 -->
                      <p class="txt_alert">
                        <span>{{ errors[id] }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="agreebox">
            <div class="agreebox_head">
              <label class="chk_article check_all" for="allAgr">
                <input
                  type="checkbox"
                  name="allAgr"
                  id="allAgr"
                  @click="setAgrChk('allAgr')"
                  :checked="state.allAgr"
                /><span>전체동의</span>
              </label>
            </div>
            <div class="agreebox_body">
              <div class="list_article">
                <ul>
                  <li>
                    <div class="article">
                      <label class="chk_article" for="agr01">
                        <input
                          type="checkbox"
                          name="agr01"
                          id="agr01"
                          @click="setAgrChk('agr01')"
                          :checked="state.agr01"
                        /><span>개인정보 이용 및 제공동의</span>
                      </label>
                      <button
                        type="button"
                        class="btn_more"
                        @click="openAgrPopup('IndvInfUseNdOfrAgr')"
                      >
                        <span>더보기</span>
                      </button>
                    </div>
                  </li>
                  <li>
                    <div class="article">
                      <label class="chk_article" for="agr02">
                        <input
                          type="checkbox"
                          name="agr02"
                          id="agr02"
                          @click="setAgrChk('agr02')"
                          :checked="state.agr02"
                        /><span>고유식별 정보 처리동의</span>
                      </label>
                      <button
                        type="button"
                        class="btn_more"
                        @click="openAgrPopup('InhrrIdfInfPcsAgr')"
                      >
                        <span>더보기</span>
                      </button>
                    </div>
                  </li>
                  <li>
                    <div class="article">
                      <label class="chk_article" for="agr03">
                        <input
                          type="checkbox"
                          name="agr03"
                          id="agr03"
                          @click="setAgrChk('agr03')"
                          :checked="state.agr03"
                        /><span>통신사 이용약관 동의</span>
                      </label>
                      <button
                        type="button"
                        class="btn_more"
                        @click="openAgrPopup('CcoUseClusAgr')"
                      >
                        <span>더보기</span>
                      </button>
                    </div>
                  </li>
                  <li>
                    <div class="article">
                      <label class="chk_article" for="agr04">
                        <input
                          type="checkbox"
                          name="agr04"
                          id="agr04"
                          @click="setAgrChk('agr04')"
                          :checked="state.agr04"
                        /><span>휴대폰 본인확인 서비스 이용약관 동의</span>
                      </label>
                      <button
                        type="button"
                        class="btn_more"
                        @click="openAgrPopup('CellSelfCnfSvcUseClusAgr')"
                      >
                        <span>더보기</span>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="btn_area">
            <button
              type="button"
              class="btn_main w100p"
              :disabled="state.isValid"
              @click="rqeMobAth"
            >
              <span>동의하고 본인인증</span></button
            ><!-- 기본 : disabled, 인증 끝난후 제거 -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { reactive, inject, onMounted, computed, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import InputArea from "@/components/01/InputArea.vue";
import util from "@/common/util";
import { load, sessionUserInfo } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import useFormValidation from "@/common/validation";

export default {
  name: "cellAth",
  components: {
    Header,
    Footer,
    InputArea,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const isRpsMbl = computed(() => store.state.elcSgnInf.isRpsMbl);
    const idfNoEl = ref(null);

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      allAgr: false,
      agr01: false,
      agr02: false,
      agr03: false,
      agr04: false,
      fnm: "",
      bdt: "",
      ccoCd: { code: "1", name: "SKT" },
      ccoLst: [
        { code: "1", name: "SKT" },
        { code: "2", name: "KT" },
        { code: "3", name: "LG U+" },
        { code: "5", name: "SKT 알뜰폰" },
        { code: "6", name: "KT 알뜰폰" },
        { code: "7", name: "LG U+ 알뜰폰" },
      ],
      cellNo: "",
      rsidNo: computed(() => state.bdt.substr(2, 7)),
      isValid: computed(() =>
        !util.isEmpty(state.fnm) &&
        !util.isEmpty(state.bdt) &&
        !util.isEmpty(state.cellNo) &&
        state.allAgr
          ? null
          : "disabled"
      ),
    });

    const { validateNameField, errors, id } = useFormValidation();
    const validateInput = () => {
      validateNameField("연락처", state.cellNo);
    };

    onMounted(async () => {
      await nextTick();
      await load();

      util.saveLog("009", "휴대폰인증"); // 009 : 화면진입
      if (!store.state.elcSgnInf.isRpsMbl && sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      } else if (store.state.elcSgnInf.isRpsMbl) {
        transkey = [];
        mtk = null;
        tk_btn_arr = [];
        setTimeout(initmTranskey, 500);
      }
    });

    const setAgrChk = (type) => {
      switch (type) {
        case "allAgr":
          if (state.allAgr) {
            state.allAgr = false;
            state.agr01 = false;
            state.agr02 = false;
            state.agr03 = false;
            state.agr04 = false;
          } else {
            state.allAgr = true;
            state.agr01 = true;
            state.agr02 = true;
            state.agr03 = true;
            state.agr04 = true;
          }
          break;
        default:
          state[type] = !state[type];
          if (state.agr01 && state.agr02 && state.agr03 && state.agr04)
            state.allAgr = true;
          else state.allAgr = false;
          break;
      }
    };

    const openAgrPopup = (type) => {
      console.log(type, state.ccoCd.code);
      dialog.lyorPop(
        "01/dialog/" + type + ".vue",
        { ccoCd: state.ccoCd.code },
        { content: "pop_agree" }
      );
    };

    const openCcoCdSelectBox = () => {
      dialog.select({ label: "선택", list: state.ccoLst }).then((result) => {
        console.log(result);
        if (!util.isEmpty(result) && !util.isNull(result)) {
          state.ccoCd = result;
        }
      });
    };

    const rqeMobAth = () => {
      let validBdt = util.replaceNum(state.bdt);
      let validCellNo = util.replaceNum(state.cellNo);

      let errorMsg = "";

      let isRpsMbl = store.state.elcSgnInf.isRpsMbl;

      if (util.isNull(state.fnm) || util.isEmpty(state.fnm)) {
        errorMsg = "성명을 입력해주세요";
      } else if (util.isNull(state.bdt) || util.isEmpty(state.bdt)) {
        errorMsg = "생년월일을 입력해주세요. (예:19800101)";
      } else if (!util.isNumeric(validBdt)) {
        errorMsg = "생년월일을 숫자로만 입력해주세요.";
      } else if (!isRpsMbl && validBdt.length != 8) {
        errorMsg = "생년월일 8자리를 입력해주세요. (예:19800101)";
      } else if (isRpsMbl && validBdt.length != 6) {
        errorMsg = "주민등록번호 앞자리를 입력해주세요.";
      } else if (isRpsMbl && util.isEmpty(idfNoEl.value.value)) {
        errorMsg = "주민등록번호 뒷자리를 입력해주세요.";
      } else if (util.isNull(state.agr01) || state.agr01 == "N") {
        errorMsg = "개인정보 이용 및 제공동의를 체크하세요.";
      } else if (util.isNull(state.agr02) || state.agr02 == "N") {
        errorMsg = "고유식별 정보 처리동의를 체크하세요.";
      } else if (util.isNull(state.agr03) || state.agr03 == "N") {
        errorMsg = "통신사 이용약관 동의를 체크하세요.";
      } else if (util.isNull(state.agr04) || state.agr04 == "N") {
        errorMsg = "휴대폰 본인확인서비스 이용약관 동의를 체크하세요.";
      } else if (util.isNull(state.ccoCd) || state.ccoCd == "") {
        errorMsg = "통신사를 선택해주세요.";
      } else if (util.isNull(validCellNo)) {
        errorMsg = "휴대폰번호를 입력해주세요.";
      } else if (!util.isNumeric(validCellNo)) {
        errorMsg = "휴대폰번호를 숫자로만 입력해주세요.";
      }

      if (!_.isEmpty(errorMsg)) {
        dialog.alert(errorMsg);
      } else {
        if (store.state.elcSgnInf.isRpsMbl) {
          let inputData = util.getMobileInputEncData(["idfNo"]);
          inputData.title = "idfNo";
          axios.reqPost("/solution/decodeIdf.do", inputData).then((result) => {
            let decodeFlag = result.data.decodeFlag;
            console.log(decodeFlag);
            if (decodeFlag) {
              axios
                .json("/inspe/retrieveMblElcSgnEcusProgInf.do", {
                  rcipeIdfNo: state.bdt,
                  inqStdDt: state.currDate,
                  inqCtnsKdCd: "120445",
                  prctrInfInqYn: "1",
                  sgnCompInclYn: "",
                })
                .then((res) => {
                  if (res.data.mblElcSgnEcusProgInfBcVo.length == 0) {
                    if (res.data.body.length == 0) {
                      dialog.alert(
                        "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                      );
                    } else {
                      // 발송건 조회 실패로 인증 X
                      dialog.alert(
                        "피보험자 전자서명을 진행할 대상 건이 없습니다."
                      );
                    }
                  } else {
                    let cusNo = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeCusNo;
                    let cusNm = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeNm;

                    if (cusNm == state.fnm) {
                      store.commit(
                        "elcSgnInf/changeMblElcSgnEcusProgInfBcVo",
                        res.data.mblElcSgnEcusProgInfBcVo
                      );
                      store.commit(
                        "elcSgnInf/changeCusInfo",
                        res.data.cusInfoMap.body
                      );
                      rqeMobAth_step2();
                    } else {
                      dialog.alert(
                        "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                      );
                    }
                  }
                });
            }
          });
        } else {
          rqeMobAth_step2();
        }
      }
    };

    function rqeMobAth_step2() {
      let param = {};
      param.inqDivCd = "2";
      axios.json("/cusInfo/getCusInfo.do", param).then(function (result) {
        console.log(result);
        let indvCusNm = result.data.body.slzCusNm; //고객명
        let indvBdt = result.data.body.bdtIdfNo; //주민번호 앞 6자리
        let gndr = result.data.body.gndr;

        let bdt = store.state.elcSgnInf.isRpsMbl ? state.bdt : state.rsidNo;

        if (indvCusNm == state.fnm && indvBdt == bdt) {
          //고객명 성별 생년월일 체크, 2018.11 성별 체크 제외
          let param = {};
          param.fnm = state.fnm;
          param.bdt = bdt;
          param.ccoDiv = state.ccoCd.code;
          param.cellNo = state.cellNo;
          param.gndr = gndr;
          param.cusNo =
            sessionUserInfo.cusNo || Math.floor(Math.random() * 1000000) + "";

          axios.json("/mobAth/rqeMobAth.do", param).then(function (result) {
            let spclRspnCd = result.data.spclRspnCd; //전문응답코드
            let athRsl = result.data.athRsl; //휴대폰인증결과
            let dialogMsg = "";

            if (spclRspnCd == "P000") {
              if (athRsl == "0000" || athRsl == "000M") {
                dialogMsg = "인증번호가 발송되었습니다.";

                //고객조회(본인 확인)
                dialog.lyorPop("01/dialog/CellAthPrcd.vue", {
                  param: {
                    fnm: state.fnm,
                    bdt: bdt,
                    ccoDiv: state.ccoCd,
                    cellNo: state.cellNo,
                    cusNo:
                      sessionUserInfo.cusNo ||
                      Math.floor(Math.random() * 1000000) + "",
                    gndr: gndr,
                    athInhrNo: result.data.athInhrNo,
                  },
                });
              } else if (athRsl == "0001") {
                dialogMsg =
                  "이동전화번호/생년월일(성별) 불일치입니다. 확인 후 다시 시도해주세요.";
              } else if (athRsl == "0002") {
                dialogMsg =
                  "이통사 고객이 아닙니다. 확인 후 다시 시도해주세요.";
              } else if (athRsl == "0004") {
                dialogMsg =
                  "이동전화번호/성명 불일치입니다. 확인 후 다시 시도해주세요.";
              } else if (athRsl == "0006") {
                dialogMsg =
                  "인증실패(법인폰) 하였습니다. 확인 후 다시 시도해주세요.";
              } else if (athRsl == "0007") {
                dialogMsg =
                  "인증실패(선불폰) 하였습니다. 확인 후 다시 시도해주세요.";
              } else if (athRsl == "0008") {
                dialogMsg = "일시정지 휴대폰입니다. 확인 후 다시 시도해주세요.";
              }
            } else if (spclRspnCd == "P001") {
              dialogMsg =
                "주민번호 유효성(체크섬) 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "P005") {
              dialogMsg =
                "참가기관ID 존재하지 않습니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "P013") {
              dialogMsg =
                "서비스이용 권한 없습니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S101") {
              dialogMsg =
                "이동통신사 구분 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S102") {
              dialogMsg =
                "이동통신사 통신 오류(이통사 타임아웃 및 연결오류)입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S602") {
              dialogMsg = "SMS발송구분 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S603") {
              dialogMsg = "내부 DB오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S700") {
              dialogMsg =
                "개인구분코드 입력되지 않았습니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "S733") {
              dialogMsg =
                "명의도용차단 설정에 따른 본인인증 미대상입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "L399") {
              dialogMsg =
                "인증 입력값 오류(주민번호, 성명, 휴대폰번호)입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "E998") {
              dialogMsg = "기타 권한 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "E999") {
              dialogMsg = "내부시스템 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "E###") {
              dialogMsg = "기타시스템 오류입니다. 확인 후 다시 시도해주세요.";
            } else if (spclRspnCd == "0000") {
              dialogMsg =
                "메리츠화재 전산에 등록된 휴대폰번호와 일치하지 않습니다.";
            } else {
              dialogMsg =
                "인증번호 발송 요청이 실패하였습니다. 잠시 후 다시 시도해주세요.";
            }

            dialog.alert(dialogMsg);
          });
        } else {
          let dialogMsg = "";
          if (indvCusNm != state.fnm) {
            if (util.isAlpha(state.fnm)) {
              //영문명 입력 시
              dialogMsg +=
                "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다. 영문명은 대소문자, 띄어쓰기 확인해주세요.";
            } else {
              dialogMsg +=
                "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다.";
            }
          }
          if (indvBdt != bdt) {
            dialogMsg +=
              "메리츠화재 전산에 등록된 생년월일 정보와 일치하지 않습니다. 생년월일을 확인해주세요.";
          }
          dialog.alert(dialogMsg);
        }
      });
    }

    return {
      state,
      setAgrChk,
      openAgrPopup,
      openCcoCdSelectBox,
      rqeMobAth,
      errors,
      id,
      validateInput,
      isRpsMbl,
      idfNoEl,
    };
  },
};
</script>
